module.exports = __webpack_public_path__ + "static/img/user.525104fc.png";